import { createContext, Fragment, useContext, useEffect, useState } from "react";
import api, { setAuthToken } from "@/lib/api";
import { setLang } from "@/i18n";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = user

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.access_token) setAuthToken(data.access_token);
    setUser(data);
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    if (data.access_token) setAuthToken(data.access_token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    setAuthToken(null);
    setUser(false);
  };

  // UI-taal volgt de ingelogde gebruiker; bij wissel wordt de app opnieuw opgebouwd.
  // Niet ingelogd: taal uit ?lang= (links in e-mails) of eerder gekozen taal op het inlogscherm.
  const [anonLang, setAnonLangState] = useState(() => {
    const q = new URLSearchParams(window.location.search).get("lang");
    if (q) localStorage.setItem("ck_lang", q);
    return q || localStorage.getItem("ck_lang") || "nl";
  });
  const setAnonLang = (l) => { localStorage.setItem("ck_lang", l); setAnonLangState(l); };
  const lang = user ? (user.language || "nl") : anonLang;
  setLang(lang);

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, refresh, setAnonLang }}>
      <Fragment key={lang}>{children}</Fragment>
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
